import { ISlot } from "./slot.model";

export interface IProviderSlot {
    slotName: string;
    slots: Array<ISlot>;
}